import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Clock } from "lucide-react";
import { useCategories } from "@/context/CategoriesContext";

function fmtDate(iso) {
  const d = new Date(iso);
  return {
    day: d.toLocaleDateString("en-GB", { day: "2-digit" }),
    month: d.toLocaleDateString("en-GB", { month: "short" }).toUpperCase(),
    weekday: d.toLocaleDateString("en-GB", { weekday: "short" }).toUpperCase(),
    time: d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" }),
  };
}

export default function EventCard({ event, index = 0, city = "worcester" }) {
  const { sportLabel, teamLabel } = useCategories();
  const d = fmtDate(event.start_at);
  return (
    <Link
      to={`/${city}/event/${event.id}`}
      data-testid={`event-card-${event.id}`}
      className="group block bg-ec-surface border border-white/10 hover:border-ec-volt/60 transition-colors animate-fade-up"
      style={{ animationDelay: `${Math.min(index, 10) * 50}ms` }}
    >
      <div className="relative h-44 overflow-hidden">
        <img
          src={event.image}
          alt={event.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
        <span className="absolute top-3 left-3 overline bg-black/70 backdrop-blur px-2.5 py-1 text-ec-volt border border-ec-volt/30">
          {sportLabel(event.sport)}
        </span>
        <div className="absolute bottom-3 left-3 flex items-end gap-2">
          <span className="font-heading text-4xl leading-none text-ec-volt">{d.day}</span>
          <div className="mb-0.5">
            <div className="font-heading text-lg leading-none">{d.month}</div>
            <div className="overline text-zinc-300">{d.weekday}</div>
          </div>
        </div>
      </div>
      <div className="p-5">
        <h3 className="font-heading text-2xl leading-none tracking-wide group-hover:text-ec-volt transition-colors">
          {event.title}
        </h3>
        {event.team && (
          <p className="overline text-zinc-500 mt-2">{teamLabel(event.team)}</p>
        )}
        <div className="flex items-center gap-4 mt-4 text-sm text-zinc-400">
          <span className="inline-flex items-center gap-1.5">
            <Clock size={15} /> {d.time}
          </span>
          <span className="inline-flex items-center gap-1.5 truncate">
            <MapPin size={15} /> {event.venue}
          </span>
        </div>
      </div>
    </Link>
  );
}
